<div id="advertising-impact-chart-container"></div>
<app-no-widget-data *ngIf="!this.data?.dailyImpact?.length && !loading"></app-no-widget-data>
<app-loader *ngIf="loading"></app-loader>